// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"b826f4e7","645":"9e91b7c3","828":"3d294390"}[chunkId] + ".chunk.js";
};